import { getStoreFor } from 'Stores/StoreInstances'
import BaseStore from 'Stores/base_store/BaseStore'
import Agencies from 'DataServices/Agencies'
import { action } from 'mobx'

const STORE_TYPE = 'Agencies'

export function getAgenciesStoreFor (param, opts = {}) {
  return getStoreFor(AgenciesStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

export class AgenciesStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll (overridePayload) {
    let payload = overridePayload || {
      ...this._filter,
    }
    return Agencies.getAll({
      ...payload,
    })
  }

  @action
  _fetchOne () {
    return Agencies.getById(this._filter.id)
  }
}
